export const EVENT_NAME = {
  QUICK_PICKS_CARD_CTA_CLICKED: "Quick Picks CTA Clicked"
};

export const MODULE = "quick_picks";
